import { ReactComponent as MenuSvg } from '../../../../assets/icons/Menu.svg';

import { createIconComponent } from './createIconComponent';

export const MenuIcon = createIconComponent(MenuSvg);
